module.exports = __webpack_public_path__ + "img/c05_buildingtechauxiliacampupgrade1_Normal_ua.25224fdc.webp";